<template>
  <div class="container">
    <div>
      <div class="productinfo">
        <div class="imgbox"> <img :src="productDetail.url" alt="" /></div>
        <div>{{ productDetail.name }}</div>
      </div>
      <div class="item">
        <span>描述相符</span>
        <van-rate
          v-model="productRating"
          :size="22"
          color="#FF8D00"
          void-icon="star"
          @change="rateInfo(productRating, 'productRating')"
        />
        <span class="info">{{ rateProduct }}</span>
      </div>
      <div class="item">
        <span>商品评分</span>
        <van-rate
          v-model="serviceRating"
          :size="22"
          color="#FF8D00"
          void-icon="star"
          @change="rateInfo(serviceRating, 'serviceRating')"
        />
        <span class="info">{{ rateService }}</span>
      </div>
      <div class="item">
        <span>物流评分</span>
        <van-rate
          v-model="logisticsScore"
          :size="22"
          color="#FF8D00"
          void-icon="star"
          @change="rateInfo(logisticsScore, 'logisticsScore')"
        />
        <span class="info">{{ rateLogistics }}</span>
      </div>
      <div class="message">
        <textarea
          class="msg"
          placeholder="宝贝是否满足了你的期待？说说你的使用心得分享给其他想购买的朋友吧。"
          v-model="content"
          style="resize: none"
        ></textarea>
        <van-uploader
          v-model="fileList"
          :after-read="afterRead"
          multiple
          :max-count="5"
          :max-size="5 * 1024 * 1024"
          @oversize="onOversize"
          @delete="beforeDelete"
        />
        <span class="tips">图片大小不能超过5m</span>
      </div>
    </div>
    <div class="btn" @click="sendcomment()">提交评价</div>
  </div>
</template>

<script>
import { mProductComment, uploadImg } from "@/api/api";
export default {
  data() {
    return {
      content: "",
      orderNo: "",
      productRating: 5,
      serviceRating: 5,
      logisticsScore: 5,
      comment: "",
      productName: "",
      rateProduct: "非常满意",
      rateService: "非常满意",
      rateLogistics: "非常满意",
      productDetail: {},
      fileList: [],
      imglist:[]
    };
  },
  methods: {
    onOversize(file) {
      this.toast('文件大小不能超过 5M');
    },
    beforeDelete(file) {
      let con = file.file.name;
      this.imglist = this.imglist.filter(t => t.name != con)
      return true;
    },
    async afterRead(file) {
      // 此时可以自行将文件上传至服务器
      var formData = new FormData();

      //可以通过append()方法来追加数据
      console.log(this.fileList);
      for (let index = 0; index < this.fileList.length; index++) {
        formData.append("file", this.fileList[index].file);
        if (index != 0) {
          formData.set("file", this.fileList[index].file);
        }
        console.log(formData);
        const res = await uploadImg(formData);
        if (res.code == "0000") {
          // let con = this.fileList[this.fileList.length - 1].file.name;
          // this.$set(this.imgUrlll, con, res.data)
          this.imglist.push({name:this.fileList[index].file.name,url:res.data})
        }
      }
    },
    rateInfo(rate, type) {
      let rateinfo = ["很不满意", "不满意", "一般", "满意", "非常满意"];
      if (type == "productRating") {
        this.rateProduct = rateinfo[rate - 1];
      } else if (type == "serviceRating") {
        this.rateService = rateinfo[rate - 1];
      } else if (type == "logisticsScore") {
        this.rateLogistics = rateinfo[rate - 1];
      }
    },
    async sendcomment() {
      let imgUrllist=''
      if ( this.imglist.length>0) {
        this.imglist.forEach(element => {
          imgUrllist += (element.url+',')
        });
      }
      
      let params = {
        buyerId:
          this.$cookies.get("memberId") || sessionStorage.getItem("memberId"),
        content: this.content,
        orderNo: this.$route.query.orderNo,
        productId: this.$route.query.productId,
        productCode: this.$route.query.productCode,
        productRating: this.productRating,
        productName: this.$route.query.name,
        serviceRating: this.serviceRating,
        logisticsScore: this.logisticsScore,
        commentImg:imgUrllist,
        commentType:imgUrllist==''?0:1
      };
      console.log(params)
      const res = await mProductComment(params);
      if (res.code == "0000") {
        this.$toast("评论成功");
        this.$router.push({
          path: "/productDetails?id=" + this.$route.query.productId,
        });
      }
    },
  },

  mounted() {
    this.productDetail = this.$route.query.all;
  },
};
</script>

<style lang="scss" scoped>
.container {
  .item {
    background-color: #fff;
    padding: 30px 20px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;

    span {
      display: block;
      font-size: 28px;
      font-weight: 400;
      text-align: left;
      color: #666666;
      line-height: 30px;
      margin-right: 30px;
    }
    .info {
      color: rgb(255, 141, 0);
      margin-left: 1rem;
    }
  }

  .message {
    padding: 30px;
    background-color: #fff;
    border-bottom: 1px solid #e8e8e8;

    .msg {
      border: 0;
      width: 100%;
      height: 220px;
      font-size: 28px;
      color: #666;
    }

    span {
      display: block;
      text-align: right;
      font-size: 24px;
      color: #cbcbcb;
    }
  }

  .picture {
    padding: 30px;
    background-color: #fff;

    span {
      display: block;
      font-size: 24px;
      color: #cbcbcb;
    }
  }

  .btn {
    width: 580px;
    height: 88px;
    line-height: 88px;
    margin: 80px auto;
    background: rgb(34, 131, 226);
    border-radius: 44px;
    text-align: center;
    font-size: 36px;
    font-weight: 500;
    color: #ffffff;
  }
}

textarea::-webkit-input-placeholder {
  color: #cbcbcb;
}
.productinfo {
  display: flex;
  background-color: #fff;
  padding: 30px 20px;
  .imgbox{
    width:3rem;
    img {
    width: 100%;
    border: 1px solid #e8e8e8;
  }
  }
  
  div {
    font-size: 28px;
    font-weight: 400;
    text-align: left;
    line-height: 30px;
    margin-left: 30px;
    margin-top: 1rem;
  }
}
</style>
